import { Dialog, DialogOptions } from './dialog';
// import {TrackableValue} from 'neuroglancer/trackable_value';
import { ConfigStorage } from 'neuroglancer/viewer_state';
import { viewer } from 'src/main';
export class ConfigDialog extends Dialog {
  configStorage: ConfigStorage; 
  constructor(parent?: HTMLElement, content?:HTMLElement|string, configStorage?: ConfigStorage | undefined, options?: DialogOptions) {
    super(parent, options)
    if (configStorage) this.configStorage = configStorage
    if (content) {
      if (typeof (content) === 'string') {
        this.content.innerHTML = content
      } else {
        setTimeout(() => {
          this.content.appendChild(content)
        })
      }
    }
    parent?.addEventListener('mouserenter', ()=>{
      if(!configStorage?.activedTool?.value)return
      if(!viewer.selectedLayer.layer || !viewer.selectedLayer.layer.name.includes(configStorage?.activedTool?.value)){
        viewer.selectedLayer.layer = undefined;
        viewer.selectedLayer.layer = viewer.layerManager.managedLayers.filter((item:any)=> item.name === `${configStorage?.activedTool?.value}`)[0];
      }
    })
    this.buttonClose.addEventListener('click', () => {
      if (configStorage) configStorage.activedTool.value = undefined
    });
  }
  close () {
    if (this.configStorage) this.configStorage.activedTool.value = undefined
    if (document.body.querySelector(".can_zoom_move_container_unique")) {
      document.body.removeChild((document.body.querySelector(".can_zoom_move_container_unique") as HTMLDivElement));
    }
    viewer.selectedLayer.layer = undefined;
  }
}

export class ConfigIndependDialog extends Dialog {
  configStorage: ConfigStorage; 
  constructor(parent?: HTMLElement, content?:HTMLElement|string, options?: DialogOptions) {
    super(parent, options)
    if (content) {
      if (typeof (content) === 'string') {
        this.content.innerHTML = content
      } else {
        setTimeout(() => {
          this.content.appendChild(content)
        })
      }
    }
    parent?.addEventListener('mouserenter', ()=>{
      if(!this.configStorage?.activedTool?.value)return
      if(!viewer.selectedLayer.layer || !viewer.selectedLayer.layer.name.includes(this.configStorage?.activedTool?.value)){
        viewer.selectedLayer.layer = undefined;
        viewer.selectedLayer.layer = viewer.layerManager.managedLayers.filter((item:any)=> item.name === `${this.configStorage?.activedTool?.value}`)[0];
      }
    })

    this.buttonClose.onclick = () => {
      this.close()
    }
  }
  close () {
    if(document.getElementsByClassName('can_zoom_move_container_unique')[0] && this.container){
      document.body.removeChild(this.container);
    }
    if(this.container && document.getElementsByClassName('can_zoom_move_container')[0]) document.body.removeChild(this.container);
  }
}